import { render, staticRenderFns } from "./AddStaffDetails.vue?vue&type=template&id=1662fcc2&scoped=true"
import script from "./AddStaffDetails.vue?vue&type=script&lang=js"
export * from "./AddStaffDetails.vue?vue&type=script&lang=js"
import style0 from "./AddStaffDetails.vue?vue&type=style&index=0&id=1662fcc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1662fcc2",
  null
  
)

export default component.exports